import { render, staticRenderFns } from "./ActiveHostingPlanSelector.vue?vue&type=template&id=674724c8&scoped=true"
import script from "./ActiveHostingPlanSelector.vue?vue&type=script&lang=js"
export * from "./ActiveHostingPlanSelector.vue?vue&type=script&lang=js"
import style0 from "./ActiveHostingPlanSelector.vue?vue&type=style&index=0&id=674724c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674724c8",
  null
  
)

export default component.exports